<template>
  <div class="cont-datos">
    <div v-for="(column, index) in aData[0].slice(1)" :key="index" class="item-dato d-flex justify-center align-center mt-2">
      <h2 class="ma-0 text-center ntitlesdark--text">{{ aData[1][index + 1] || 0 }}</h2>
      <p class="ma-0 mr-1 label-count text-center">{{ aData[0][index + 1] }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    aData: Array, // Array en estructura de matriz aData: [[][]]
  },
};
</script>

<style lang="scss" scoped>
.cont-datos {
  display: flex; /* Para que los elementos internos estén en línea */
}
.item-dato {
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  align-items: center; /* Alineación vertical al centro */
  font-size: 0.875rem;

  h2 {
    font-weight: 400;
    margin-bottom: 5px; /* Espacio entre h2 y p */
  }

  p {
    margin: 0; /* Ajuste de margen para el párrafo */
  }
}
.text-count {
  color: #003743 !important;
}
.label-count {
  color: #757575 !important;
}

@media only screen and (min-width: 768px ) and (max-width: 1400px) {
  .item-dato {
    margin-right: 3px;
  }
}
@media only screen and (min-width: 1264px ) and (max-width: 1904px) {
  .label-count {
    font-size: 12px;
  }
}

</style>
